// src/services/BilletterieService.jsx

import { base_url } from "../utils/constante";

function authHeaders() {
    const token = localStorage.getItem("token");
    return {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
}

// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Ses réservations
// ══════════════════════════════════════════════════════════

export async function getReservationsCreateur() {
    const res = await fetch(`${base_url}createur/reservations`, {
        headers: authHeaders(),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erreur");
    return data.reservations;
}

// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Valider un billet
// ══════════════════════════════════════════════════════════

export async function validerBillet(id) {
    const res = await fetch(`${base_url}createur/reservations/${id}/valider`, {
        method: "PATCH",
        headers: authHeaders(),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erreur");
    return data;
}

// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Personnaliser le billet d'un événement
// ══════════════════════════════════════════════════════════

export async function personnaliserBillet(evenementId, { imageBillet, infoBillet }) {
    const fd = new FormData();
    if (imageBillet instanceof File) fd.append("image_billet", imageBillet);
    if (infoBillet !== undefined) fd.append("info_billet", infoBillet);

    const res = await fetch(`${base_url}createur/evenement/${evenementId}/billet`, {
        method: "POST",
        headers: authHeaders(), // pas de Content-Type → multipart auto
        body: fd,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erreur");
    return data;
}

// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Configurer la billetterie d'un événement
// ══════════════════════════════════════════════════════════

export async function configurerBilletterie(evenementId, payload) {
    const res = await fetch(`${base_url}createur/evenement/${evenementId}/billetterie`, {
        method: "POST",
        headers: { ...authHeaders(), "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Erreur");
    return data;
}
// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Liste paginée des événements en billetterie
//  Thrundrz uniquement (filtre + pagination faits côté SQL,
//  fini le filtrage côté client qui cassait la pagination)
// ══════════════════════════════════════════════════════════

export async function getEvenementsBilletterie(page = 1) {
    const res = await fetch(`${base_url}createur/billetterie/evenements?page=${page}`, {
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error("Erreur lors du chargement des événements");
    return res.json(); // { events, pagination }
}

// ══════════════════════════════════════════════════════════
//  CRÉATEUR — Statistiques globales (courbe + classement)
// ══════════════════════════════════════════════════════════

export async function getStatistiquesBilletterie() {
    const res = await fetch(`${base_url}createur/billetterie/statistiques`, {
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error("Erreur lors du chargement des statistiques");
    return res.json(); // { total_billets, revenu_total, classement, courbe }
}